import api from "./api";

export function getAccommodationDetails(page = 1, limit = 10, search = "") {
  return api.get(`/accommodationdetails?page=${page}&limit=${limit}&search=${search}`);
}

export function getAccommodationDetailsById(id) {
  return api.get(`/accommodationdetails/${id}`);
}

export function createAccommodationDetails(data) {
  return api.post("/accommodationdetails", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateAccommodationDetails(country_id, data) {
  return api.put(`/accommodationdetails/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteAccommodationDetails(id) {
  return api.delete(`/accommodationdetails/${id}`);
}